<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center mb-2">
        <h1>Trials By Investigators</h1>
          <v-alert v-if="investigators == false" color="info" icon="new_releases" :value="true">
            There are no investigators.
          </v-alert>
      </v-flex>
      <v-flex xs10 sm11 md11 align-content-space-between mt-4 mb-0 ml-0 mr-0>
        <v-card class="info" v-for="item in investigators" v-bind:key="item.investigatorId"  :to="'/Trials/investigators/' + item.investigatorId">
          <v-list class="listItems">
              <v-list-tile class="pb-2 pt-2 pl-2">
                <v-list-tile-avatar>
                  <person-icon left class="icon" />
                </v-list-tile-avatar>
                <v-list-tile-content class="pl-2">
                  <v-list-tile-title v-html="item.investigatorName"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn light flat ripple>
                    <v-icon v-bind:color="item.active ? 'grey' : 'grey'">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <!--
                <v-list-tile-action v-if="userIsAuthenticated" class="orange">
                  <template>
                    <app-edit-investigator-dialog :investigator="investigator(index)"></app-edit-investigator-dialog>
                  </template>
                </v-list-tile-action>
                <v-list-tile-action v-if="userIsAuthenticated" class="red darken-3">
                  <v-btn dark flat class="red darken-3 pa-2" @click="onDeleteInvestigator(item)">
                    <v-icon dark class="text--lighten-1">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              -->
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs2 sm1 md1 ml-0 mr-0 mb-0 mt-4 justify-center v-if="userIsAuthenticated">
        <v-card class="info" v-for="(item2, index2) in investigators" v-bind:key="item2.investigatorId">
          <v-list class="listItems pa-0">
              <v-list-tile class="pa-2">
        				<app-edit-investigator-dialog :investigator="investigator(index2)"></app-edit-investigator-dialog>
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 mb-4 v-if="userIsAuthenticated">
        <v-card :to="'/investigator/new'">
          <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
            Add Investigator
            <v-icon class="text-xs-right">add</v-icon>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    investigators () {
      return this.$store.getters.loadedInvestigators
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    investigator (index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedInvestigator(this.investigators[index].investigatorId))
      return this.$store.getters.loadedInvestigator(this.investigators[index].investigatorId)
    },
    onDeleteInvestigator (investigator) {
      console.log('Delete this: ' + JSON.stringify(investigator))
      this.$store.dispatch('deleteInvestigatorData', investigator)
      this.$router.push('/investigators')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Archive.vue?23e6e2b6